<template>
  <PrimevuePanel class="border-solid border-1 surface-border">
    <template #header>
      <div class="flex align-items-center">
        <span class="font-bold" >
          {{ this.$props.internal ? '' : (this.$props.message.subject || 'Bez predmetu')}}
        </span>
      </div>
    </template>
    <template #icons>
      <div class="justify-content-end text-right">
        <em>
          {{ Utils.parseToSlovakDateTime(this.$props.message.createdAt) || 'Neznámy dátum' }}
        </em>
      </div>
    </template>
    <div class="email-meta formgrid grid mb-2">
      <div class="col-12">
        <div class="formgrid grid">
          <em class="col-2 text-500">Od:</em>
          <div class="col-10">
            <strong>{{ this.$props.message.fromName || 'Neznámy odosielateľ' }}</strong>
            <span v-if="!this.$props.internal" class="ml-1">&lt;{{ this.$props.message.fromEmail  || 'Bez emailu'}}&gt;</span>
          </div>
        </div>
        <div v-if="!this.$props.internal" class="formgrid mt-0 grid">
          <em class="col-2 text-500">Pre:</em>
          <div class="col-10">
            <span>{{ this.$props.message.toName  || ''}}</span>
            <span class="ml-1">{{ this.$props.message.toEmail  || 'Bez emailu'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!this.$props.internal" class="email-body scrollable-body">
      <!-- Render processed HTML with delimiters -->
      <div v-html="formattedHtml"></div>
    </div>
    <div v-else class="email-body">{{this.$props.message.bodyTxt}}</div>

    <AttachmentList
        :messageId="String(this.$props.message.id)" :internal="this.$props.internal" :attTypeId="0"
    />
  </PrimevuePanel>
</template>
<script lang="ts">
import DOMPurify from 'dompurify';
import Security from './security';
import { store } from './store';
import Utils from '@/components/utils';
import PrimevuePanel from 'primevue/panel';
import AttachmentList from '@/components/AttachmentList.vue';

export default {
  name: 'DetailMessage',
  components: {
    PrimevuePanel,
    AttachmentList,
  },
  props: {
    message: { type: Object, required: true },
    internal: Boolean,

  },
  data() {
    return {
      store,
      formattedHtml: '',
    };
  },
  computed: {
    Utils() {
      return Utils;
    },
  },
  watch: {
    'message.bodyHtml': {
      immediate: true,
      handler(newHtml) {
        this.formattedHtml = this.processEmailBody(newHtml);
      },
    },
  },
  methods: {
    processEmailBody(bodyHtml) {
      // Sanitize the input to remove unsafe HTML
      let sanitized = DOMPurify.sanitize(bodyHtml, {
        WHOLE_DOCUMENT: false,
        ADD_ATTR: ['style'], // Allow inline styles
      });

      // Decode `&gt;` back to `>` for processing
      sanitized = sanitized.replace(/&gt;/g, '>');

      const lines = sanitized.split('\n');
      let processedHtml = '';
      let currentQuoteLevel = 0;

      lines.forEach((line) => {
        const match = line.match(/^(>+)\s?(.*)/);

        if (match) {
          const quoteLevel = match[1].length; // Count `>` markers
          const content = match[2]; // Content of the line

          // Close blockquotes if the nesting decreases
          if (quoteLevel < currentQuoteLevel) {
            processedHtml += '</blockquote>'.repeat(currentQuoteLevel - quoteLevel);
          }

          // Open blockquotes if the nesting increases
          if (quoteLevel > currentQuoteLevel) {
            processedHtml += '<blockquote>'.repeat(quoteLevel - currentQuoteLevel);
          }

          // Add the content without the `>` markers
          processedHtml += `<div>${content || '<br>'}</div>`;
          currentQuoteLevel = quoteLevel;
        } else {
          // Close all open blockquotes when a non-quoted line appears
          if (currentQuoteLevel > 0) {
            processedHtml += '</blockquote>'.repeat(currentQuoteLevel);
            currentQuoteLevel = 0;
          }

          // Add the non-quoted line
          processedHtml += `<div>${line.trim() || '<br>'}</div>`;
        }
      });

      // Close any remaining blockquotes
      if (currentQuoteLevel > 0) {
        processedHtml += '</blockquote>'.repeat(currentQuoteLevel);
      }

      return processedHtml;
    },
  },
  beforeMount() {
    Security.requireToken();
    store.selectModul = this.$route.path.split("/")[1]
  },
};
</script>
<style scoped>
.email-meta {
  font-family: Arial, sans-serif;
  margin-bottom: 1rem;
}
.email-body {
  overflow-y: auto;
  max-height: 400px;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}
blockquote {
  margin: 0;
  padding-left: 10px;
  border-left: 2px solid #ccc;
  color: #555;
  font-style: italic;
}
blockquote blockquote {
  border-color: #bbb;
}
blockquote blockquote blockquote {
  border-color: #aaa;
}
a {
  color: #007bff;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>